import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { usePrefs } from 'wsm-common-data';
import { CommonModal } from 'wsm-common-modal';

const ReturnsItem = ({
	title,
	content,
	opensModal,
	linkText,
	modalContent
}) => {
	const [isOpenModal, setOpenModal] = useState(false);
	const toggleOpenModal = () => {
		setOpenModal((previous) => !previous);
	};
	const prefs = usePrefs();
	const showLink = prefs.returnsLink === 'true' || false;

	return (
		<div className="d-flex align-items-start my-3 col-sm-12 col-md-6">
			<div className="mr-3">
				<div
					className="rounded-circle d-flex align-items-center justify-content-center flex-column"
					style={{
						width: '64px',
						height: '64px',
						border: 'var(--spot-icon-stroke-width) solid var(--spot-icon-stroke-primary-color)',
						lineHeight: '1'
					}}
				>
					<b className="text-primary ddc-font-size-large">
						{prefs.returnsRate}
					</b>
					<span
						className="ddc-font-size-xxsmall"
						style={{ lineHeight: '1.5' }}
					>
						{prefs.returnsUnitofTime}
					</span>
				</div>
			</div>
			<div>
				<h4>{title}</h4>
				<div className="mt-1 mb-3">{content}</div>
				{opensModal && showLink && (
					<>
						<button
							className="text-link text-link-muted text-decoration-underline"
							onClick={toggleOpenModal}
							type="button"
						>
							{linkText}
						</button>
						<CommonModal
							title={title}
							isOpen={isOpenModal}
							onClose={toggleOpenModal}
						>
							{modalContent}
						</CommonModal>
					</>
				)}
			</div>
		</div>
	);
};

ReturnsItem.propTypes = {
	title: PropTypes.string.isRequired,
	content: PropTypes.string.isRequired,
	linkText: PropTypes.string,
	opensModal: PropTypes.bool,
	modalContent: PropTypes.element
};
export default ReturnsItem;
